import { cookieDublicator } from "./CookieDublicator";
import { customTime } from "./CustomTime";
export class JsCookie {
    static getInstance() {
        if (!JsCookie.instance) {
            JsCookie.instance = new JsCookie();
        }
        return JsCookie.instance;
    }
    constructor() {
        this.defaults = {};
    }
    extend(...args) {
        let i = 0;
        let result = {};
        for (; i < args.length; i++) {
            let attributes = args[i];
            for (let key in attributes) {
                result[key] = attributes[key];
            }
        }
        return result;
    }
    set(key, value, attributes, converter = {}) {
        let result;
        if (typeof document === 'undefined') {
            return false;
        }
        attributes = this.extend({
            path: '/'
        }, this.defaults, attributes);
        if (typeof attributes.expires === 'number') {
            let expires = customTime.get();
            expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
            attributes.expires = expires;
        }
        // We're using "expires" because "max-age" is not supported by IE
        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
        try {
            result = JSON.stringify(value);
            if (/^[\{\[]/.test(result)) {
                value = result;
            }
        }
        catch (e) {
        }
        if (!converter.write) {
            value = encodeURIComponent(String(value))
                .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        }
        else {
            value = converter.write(value, key);
        }
        key = encodeURIComponent(String(key));
        key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
        key = key.replace(/[\(\)]/g, escape);
        let stringifiedAttributes = '';
        for (let attributeName in attributes) {
            if (!attributes[attributeName]) {
                continue;
            }
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) {
                continue;
            }
            stringifiedAttributes += '=' + attributes[attributeName];
        }
        cookieDublicator.dublicateCookieToLocalStorageIfItNeed(key, decodeURIComponent(value), attributes);
        document.cookie = key + '=' + value + stringifiedAttributes;
        return true;
    }
    get(key, converter = {}, json = false, useDublicator = true) {
        if (typeof document === 'undefined') {
            return;
        }
        const cookieValue = this.checkDoubleDecode(this.pureGet(key, converter, json));
        if (!useDublicator) {
            return cookieValue;
        }
        const lsData = cookieDublicator.getStoredValue(key);
        if (lsData && cookieValue && lsData.value !== cookieValue) {
            // update    
            cookieDublicator.dublicateCookieToLocalStorageIfItNeed(lsData.key, cookieValue, lsData);
            return cookieValue;
        }
        if (lsData === null) {
            return cookieValue;
        }
        // restore
        cookieDublicator.dublicateLocalStorageToCookieIfItNeed(key, lsData);
        return this.pureGet(key, converter, json);
    }
    pureGet(key, converter = {}, json = false) {
        let result;
        if (!key) {
            result = {};
        }
        let cookies = document.cookie ? document.cookie.split('; ') : [];
        let rdecode = /(%[0-9A-Z]{2})+/g;
        let i = 0;
        for (; i < cookies.length; i++) {
            let parts = cookies[i].split('=');
            let cookie = parts.slice(1).join('=');
            if (!json && cookie.charAt(0) === '"') {
                cookie = cookie.slice(1, -1);
            }
            try {
                let name = parts[0].replace(rdecode, decodeURIComponent);
                cookie = converter.read ? converter.read(cookie, name) : cookie.replace(rdecode, decodeURIComponent);
                if (json) {
                    try {
                        cookie = JSON.parse(cookie);
                    }
                    catch (e) { }
                }
                if (key === name) {
                    result = cookie;
                    break;
                }
                if (!key) {
                    result[name] = cookie;
                }
            }
            catch (e) { }
        }
        return result;
    }
    getJson(key, converter = {}) {
        return this.get(key, converter, true);
    }
    remove(key, attributes) {
        return this.set(key, '', this.extend(attributes, {
            'max-age': -1
        }));
    }
    ;
    checkDoubleDecode(cookieValue, countRecurs = 0) {
        if (cookieValue) {
            try {
                const decodedValue = decodeURIComponent(cookieValue);
                if (cookieValue != decodedValue && countRecurs < 10) {
                    return this.checkDoubleDecode(decodedValue, countRecurs++);
                }
            }
            catch (error) { }
        }
        return cookieValue;
    }
}
;
